import './App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

function App() {

  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Making request to server...');
        const response = await axios.get('https://m.calc5.ru');
        console.log('Response received from server:', response);
        setData(response.data.message);
      } catch (error) {
        console.error('Ошибка при выполнении запроса:', error);
      }
    };

    fetchData();
  }, []);


  return (
    <div className="App">
      <header className="App-header">
        <h1>Данные с сервера</h1>
        <div>
          {data ? (
            <div>Данные загружены: {data}</div>
          ) : (
            <div>Загрузка данных...</div>
          )}
        </div>
      </header>
    </div>
  );
}

export default App;
